import { freeScreenScope } from "src/configs/subscription-access";
import { backend } from "src/api";
import { DataResponse } from "src/utils/data";

class DataLakeApi {
  async getTypes() {
    const response = await backend.get("/datalake/types");
    return response.data;
  }

  async getData(requests, scope = freeScreenScope() || "paid", aptId = new URLSearchParams(window.location.search).get("id")) {
    const noteScope = /^note-(\d+)-(\d+)$/.exec(scope);
    const response = noteScope
      ? await backend.post(`/analysis-notes/published/${noteScope[1]}/analyzes/${noteScope[2]}/data`, requests)
      : scope === "paid"
      ? await backend.post("/datalake/data", requests)
      : await backend.post(`/free/series/${scope}`, requests.map(request => ({
        aptId: scope === "apartment" ? aptId : undefined,
        dataset: `${request.dataType}${request.dataName}${request.dateType}${request.dataRange}${request.dataSource}`,
        selection: request.options || {},
      })));
    const result = [];
    for (var lake of response.data) {
      var data = new DataResponse(
        lake.data,
        lake.dates,
        lake.request,
        lake.displayName,
        lake.dateType
      );
      result.push(data);
    }
    return result;
  }
}

export const datalakeApi = new DataLakeApi();
